import { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import { Input, Drawer, Row, Col } from "antd";
import { RATypography } from "../customs/Typography";
import { useSelector } from "react-redux";
import dayjs from "dayjs";

import "react-phone-number-input/style.css";
import { IconCloseSvg } from "../svgs";
import { SvgTime } from "@/assets/icons";
import { RAButtonPrimary } from "../customs";
import { isFormatTime12H } from "@/stores/slices/authSlice";

const HOURS_12_HOURS = ["12", "01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11"];

const HOURS_24_HOURS = [
	"00",
	"01",
	"02",
	"03",
	"04",
	"05",
	"06",
	"07",
	"08",
	"09",
	"10",
	"11",
	"12",
	"13",
	"14",
	"15",
	"16",
	"17",
	"18",
	"19",
	"20",
	"21",
	"22",
	"23",
];

const MINUTES = ["00", "05", "10", "15", "20", "25", "30", "35", "40", "45", "50", "55"];
const AM_PM = ["AM", "PM"];
export const RAInputTimePickerMobile = ({
	value,
	title,
	onChange,
	prefix,
	disabled = false,
	placeholder = "Select time",
	...props
}) => {
	const isTime12H = useSelector(isFormatTime12H);
	const [open, setOpen] = useState(false);
	const [time, setTime] = useState();

	useEffect(() => {
		return () => {
			if (document.body.style.overflow === "hidden") {
				document.body.style.overflow = "auto";
			}
		};
	}, []);

	useEffect(() => {
		if (value) {
			let date = dayjs(value);
			setTime({
				hour: isTime12H ? date.format("hh") : date.format("HH"),
				minute: date.format("mm"),
				amPm: isTime12H ? date.format("A") : "",
			});
		}
	}, [value]);

	useEffect(() => {
		if (open) {
			document.body.style.overflow = "hidden";
		} else {
			document.body.style.overflow = "auto";
		}
	}, [open]);

	const convert24Hour = (hour, amPm) => {
		let hours = parseInt(hour);
		if (amPm === AM_PM[1] && hours < 12) {
			hours = hours + 12;
		}
		if (amPm === AM_PM[0] && hours == 12) {
			hours = hours - 12;
		}
		return hours;
	};

	return (
		<ContainerOutter key={value}>
			<Container>
				{title && (
					<WrapperTitle>
						<RATypography color="#595959" variant="sub-heading4">
							{title}
						</RATypography>
					</WrapperTitle>
				)}

				<StyledInput
					prefix={prefix || <SvgTime color="#595959" />}
					placeholder={placeholder}
					value={time && `${time.hour}:${time.minute} ${isTime12H ? time.amPm : ""}`}
					readOnly="readonly"
					disabled={disabled}
					onClick={() => setOpen(true)}
				/>
				<Drawer
					id="time-picker-mobile"
					title={<InputHeader onClose={() => setOpen(false)} />}
					rootClassName="passenger-drawer"
					placement={"bottom"}
					closable={false}
					onClose={() => {
						setOpen(false);
					}}
					open={open}
					height={320}
					bodyStyle={{
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
						justifyContent: "center",
						padding: 0,
						margin: 0,
						width: "100%",
					}}
					contentWrapperStyle={{
						maxWidth: "667px",
						left: 0,
						right: 0,
						marginLeft: "auto",
						marginRight: "auto",
					}}
				>
					<InputTimePickerBody
						{...props}
						onApply={(val) => {
							setTime(val);
							setOpen(false);
							if (value) {
								let date = dayjs(value);
								const newdate = date
									.set("hour", isTime12H ? convert24Hour(val.hour, val.amPm) : parseInt(val.hour))
									.set("minute", parseInt(val.minute));
								onChange?.(newdate.toISOString());
							} else {
								let date = dayjs();
								const newdate = date
									.set("hour", isTime12H ? convert24Hour(val.hour, val.amPm) : parseInt(val.hour))
									.set("minute", parseInt(val.minute));
								onChange?.(newdate.toISOString());
							}
						}}
						value={value}
						initialValue={value}
					/>
				</Drawer>
			</Container>
		</ContainerOutter>
	);
};

const InputHeader = ({ onClose }) => {
	return (
		<Row align="middle" justify="center">
			<RATypography variant="sub-heading3">Select time</RATypography>
			<CloseIcon onClick={() => onClose?.()}>
				<IconCloseSvg />
			</CloseIcon>
		</Row>
	);
};

const InputTimePickerBody = ({ onApply, value, initialValue }) => {
	const isTime12H = useSelector(isFormatTime12H);
	const [hour, setHour] = useState(isTime12H ? HOURS_12_HOURS[0] : HOURS_24_HOURS[0]);
	const [minute, setMinute] = useState(MINUTES[0]);
	const [amPm, setAmPm] = useState(AM_PM[0]);
	const [initTimePicker, setInitTimePicker] = useState();

	useEffect(() => {
		if (initialValue) {
			let date = dayjs(initialValue);
			setInitTimePicker({
				hour: isTime12H ? date.format("hh") : date.format("HH"),
				minute: date.format("mm"),
				amPm: isTime12H ? date.format("A") : "",
			});
		}
	}, [initialValue]);

	return (
		<TimePickerBodyContainer>
			<Row align="middle" justify={"center"} style={{ flexGrow: 1 }}>
				<Col span={8}>
					<WheelPicker
						type="hour"
						onChange={(val) => setHour(val)}
						data={isTime12H ? HOURS_12_HOURS : HOURS_24_HOURS}
						value={hour}
						initialValue={initTimePicker?.hour}
					/>
				</Col>
				<Col span={8}>
					<WheelPicker
						type="minute"
						onChange={(val) => setMinute(val)}
						data={MINUTES}
						value={minute}
						initialValue={initTimePicker?.minute}
					/>
				</Col>
				{isTime12H && (
					<Col span={8}>
						<WheelPicker
							type="am-pm"
							data={AM_PM}
							onChange={(val) => setAmPm(val)}
							value={amPm}
							initialValue={initTimePicker?.amPm}
						/>
					</Col>
				)}
			</Row>
			<Row>
				<RAButtonPrimary
					title="APPLY"
					onClick={() => {
						onApply?.({
							hour,
							minute,
							amPm,
						});
					}}
					width="100%"
				/>
			</Row>
		</TimePickerBodyContainer>
	);
};

const WheelPicker = ({ data = [], type = "", onChange, value, initialValue }) => {
	const [activeIndex, setActiveIndex] = useState();
	const datepickerRef = useRef();

	useEffect(() => {
		if (initialValue && data.indexOf(initialValue) >= 0) {
			setActiveIndex(data.indexOf(initialValue));
			datepickerRef.current.scrollTop = 18 + 36 * data.indexOf(initialValue);
		}
	}, [initialValue]);
	useEffect(() => {
		let timer;
		datepickerRef.current.onscroll = function (e) {
			clearTimeout(timer);
			e.preventDefault();
			timer = setTimeout(stoppedscrolling, 100);
		};
		const dateNumbers = datepickerRef.current.getElementsByClassName("datepicker-nr");
		let offsetArr = [0];
		for (let i = 0; i < dateNumbers.length; i++) {
			offsetArr.push(offset(dateNumbers[i]).top - offset(datepickerRef.current).top);
		}
		const stoppedscrolling = () => {
			let scrollPosition = datepickerRef.current.scrollTop;
			let closestNumber = offsetArr.reduce(function (prev, curr) {
				return Math.abs(curr - scrollPosition) < Math.abs(prev - scrollPosition) ? curr : prev;
			});
			datepickerRef.current.scrollTop = closestNumber;
			if (offsetArr.indexOf(closestNumber) >= 0) {
				onChange?.(data[offsetArr.indexOf(closestNumber)]);
				setActiveIndex(offsetArr.indexOf(closestNumber));
			}
		};
	}, []);

	const offset = (elt) => {
		var rect = elt.getBoundingClientRect(),
			bodyElt = document.body;

		return {
			top: rect.top + bodyElt.scrollTop,
			left: rect.left + bodyElt.scrollLeft,
		};
	};
	return (
		<div>
			<div className="picker">
				<div className="picker-window"></div>
				<ul id={`datepicker-${type}`} ref={datepickerRef}>
					{data.map((item, index) => {
						return (
							<li
								className="datepicker-nr"
								key={index}
								style={{
									color: activeIndex === index ? "#222222" : "#595959",
								}}
							>
								{item}
							</li>
						);
					})}
				</ul>
			</div>
		</div>
	);
};

const ContainerOutter = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	position: relative;
	align-items: center;
	justify-content: center;
`;

const Container = styled.div`
	width: 100%;
	max-width: 667px;
`;

const StyledInput = styled(Input)`
	width: 100%;
	border-radius: 12px;
	padding-left: 20px;
	padding-right: 8px;
	height: 52px;
	@media (max-width: 576px) {
		padding-left: 10px;
	}
`;
const WrapperTitle = styled.div`
	padding-bottom: 8px;
`;

const TimePickerBodyContainer = styled.div`
	padding: 19px 19px 40px 19px;
	width: 100%;
	display: flex;
	flex-direction: column;
	overscroll-behavior: none;
	max-width: 374px;
	/* @mixin hideScrollbars {
        -ms-overflow-style: none; // IE 10+
        &::-webkit-scrollbar {
            display: none;
        }
    } */

	.picker-window {
		position: absolute;
		height: 2em;
		left: 0;
		top: 50%;
		transform: translateY(-75%);
		width: 100%;
		pointer-events: none;
	}

	.picker {
		display: inline-grid;
		width: 100%;
		border-radius: 15px;
		position: relative;

		padding-left: 1rem;
		padding-right: 1rem;
		background: white;
		grid-template-columns: 1fr;
		/* font-size: calc(0.5rem + 2.5vw); */
		font-size: 18px;
		position: relative;
		font-feature-settings: "tnum";
		font-weight: 400;
		&:before,
		&:after {
			content: "";
			position: absolute;
			width: 100%;
			height: 3em;
			pointer-events: none;
		}
		&:before {
			top: -0.2em;
			background: linear-gradient(white, rgba(255, 255, 255, 0.7));
		}
		&:after {
			bottom: -0.2em;
			height: 4em;
			background: linear-gradient(rgba(255, 255, 255, 0.5), white);
		}
	}
	ul {
		/* @include hideScrollbars(); */
		/* max-height: 4em; */
		max-height: 4em;
		overflow-y: scroll;
		margin-right: 1em;
		scroll-snap-type: y mandatory;
		padding-bottom: 4.3em;
		padding-top: 4.3em;
		width: 100%;
	}
	li {
		scroll-snap-align: center;
		height: 2em;
		text-align: center;
		word-spacing: 0.2em;
	}

	.picker-day {
		padding-right: 0.5em;
		span {
			padding-left: 0.56em;
		}
	}
`;

const CloseIcon = styled.div`
	position: absolute;
	right: 12px;
	top: 12px;
	padding: 4px;
	cursor: pointer;
`;
